"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConfirmationCallCodeFormController = require("./ConfirmationCallCodeFormController");
Object.keys(_ConfirmationCallCodeFormController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfirmationCallCodeFormController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfirmationCallCodeFormController[key];
    }
  });
});